import { Controller, Shark, Utils } from "shark-mvc";
import moment from "moment-timezone";

import ApplicatorTimeRange from "../../_shark_models/ApplicatorTimeRange";
import CCADetails from "../../_shark_models/CCADetails";

import { constructionSiteCardManager } from "./constructionSiteCardManager";
import { constructionSiteManager } from "./constructionSiteManager";
import { quotationManager } from "./quotationManager";
import ccaDetailsManager from "../../controllers/ccaDetailsManager";

class TeamUpManager extends Controller {
	constructor() {
		super("teamUpManager");
	}

	appInit () {
		this.set("baseApiURL", "https://api.teamup.com/ksw14p2npoy3azxawq/{{endPoint}}?_teamup_token=720642e87891cd36d671e303585b8cb4596e81d9d8bcc3e05fc5e5a3fd114031");
	}

	getEventByCCA (CCA/*, startISODate = "", endISODate = ""*/) {
		const eventDetails = {};
		const thisYear = new Date().getFullYear();

		return fetch(`${this.get("baseApiURL").replace(/{{[\w.]+\}\}/g, "events")}&startDate=${thisYear - 1}-01-01&endDate=${thisYear + 1}-12-31&query=${CCA}`)
		.then(response => response.json())
		.then(teamUpResponse => {
			// console.log({teamUpResponse});
			if (teamUpResponse.events.length > 0) {
				const eventData = teamUpResponse.events[0];
				const eventStartDate = moment(eventData.start_dt);
				const eventEndDate = moment(eventData.end_dt);

				eventDetails.constructionEndDate = eventEndDate.format(Shark.get("dateHumanFormat"));
				eventDetails.constructionStartDate = eventStartDate.format(Shark.get("dateHumanFormat"));
				eventDetails.constructionEndDateTime = eventEndDate;
				eventDetails.constructionStartDateTime = eventStartDate;
				eventDetails.title = eventData.title;

				if (eventData.subcalendar_id) {
					return fetch(this.get("baseApiURL").replace(/{{[\w.]+\}\}/g, "subcalendars/" + eventData.subcalendar_id))
					.then(response => response.json())
					.then(teamUpCalendarResponse => {
						console.log({teamUpCalendarResponse});
						let teamName = teamUpCalendarResponse.subcalendar.name;

						if (teamName.substr(0, 24).toUpperCase() === "CALENDARIO DEFINITIVO > ") {
							teamName = teamUpCalendarResponse.subcalendar.name.substr(24);
						}
						eventDetails.constructionApplicatorTeam = teamName;
						
						return {
							data: eventDetails,
							status: "ok"
						};
					});
				}
				else {
					return {
						data: eventDetails,
						status: "ok"
					};
				}
			}
			else {
				return {
					data: eventDetails,
					status: "ko"
				};
			}
		})
		.catch(error => {
			return {
				data: eventDetails,
				error,
				status: "ko"
			};
		});
	}

	async getEventListByCCA (CCA, ncrId = ""/*, startISODate = "", endISODate = ""*/) {
		CCA = CCA.trim();
		const eventList = [];
		const thisYear = new Date().getFullYear();

		return new Promise((resolve, reject) => {
			fetch(`${this.get("baseApiURL").replace(/{{[\w.]+\}\}/g, "events")}&startDate=${thisYear - 2}-01-01&endDate=${thisYear + 1}-12-31&query=${CCA}`)
			.then(response => response.json())
			.then(teamUpResponse => {
				// console.log({teamUpResponse});
				const applicatorTeamList = Shark.get("applicatorTeamList");
				const eventCount = teamUpResponse.events.length;

				if (eventCount > 0) {
					const currCCADetails = new CCADetails({
						cca: CCA,
						status: 1,
						timeRanges: [],
						// timeSpanEnd: moment(teamUpResponse.events[0].start_dt),
						// timeSpanStart: moment(teamUpResponse.events[0].end_dt),
					});

					if (ncrId.trim() !== "") {
						currCCADetails.set("extraData.ncrId", ncrId);
					}

					teamUpResponse.events.forEach((event, index) => {
						if (
							event.custom?.cca && event.custom.cca.trim() === CCA &&
							(
								(((!event.custom?.non_conformita || event.custom.non_conformita.trim() === "") && ncrId.trim() === "") || (event.custom?.non_conformita && event.custom?.non_conformita.trim() === ncrId.trim()))
							)
						) {
							const eventDetails = {};
							// const event = event;
							const eventStartDate = moment(event.start_dt);
							const eventEndDate = moment(event.end_dt);

							const applicatorTeam = Utils.safp(applicatorTeamList, "subCalendarId", event.subcalendar_id.toString());
							
							if (currCCADetails.applicatorTeamGuid === "") {
								currCCADetails.applicatorTeamGuid = applicatorTeam?.guid ?? "";
								currCCADetails.__constructionApplicatorTeam = applicatorTeam?.name ?? "";
							}

							const newApplicatorTimeRange = new ApplicatorTimeRange({
								applicatorTeamGuid: applicatorTeam?.guid ?? "",
								guid: event.id,
								notes: event.notes ? event.notes.replace(/<p>/g, "").replace(/<\/p>/g, "") : "",
								status: 1,
								dateEnd: eventEndDate,
								dateStart: eventStartDate,
							});

							//console.log({newApplicatorTimeRange})
							currCCADetails.addTimeRange(newApplicatorTimeRange);
							
							eventDetails.constructionEndDate = eventEndDate.format(Shark.get("dateHumanFormat"));
							eventDetails.constructionStartDate = eventStartDate.format(Shark.get("dateHumanFormat"));
							eventDetails.constructionEndDateTime = eventEndDate;
							eventDetails.constructionStartDateTime = eventStartDate;
							eventDetails.applicatorTeamId = applicatorTeam?.guid ?? "";
							eventDetails.applicatorTeamGuid = applicatorTeam?.guid ?? "";
							eventDetails.constructionApplicatorTeam = applicatorTeam?.name ?? "";
							eventDetails.notes = event.notes ? event.notes.replace(/<p>/g, "").replace(/<\/p>/g, "") : "";
							eventDetails.title = event.title;
			
							eventList.push(eventDetails);
									
							if (!applicatorTeam && event.subcalendar_id) {
								fetch(this.get("baseApiURL").replace(/{{[\w.]+\}\}/g, "subcalendars/" + event.subcalendar_id))
								.then(response => response.json())
								.then(teamUpCalendarResponse => {
									console.log({teamUpCalendarResponse});
									let teamName = teamUpCalendarResponse.subcalendar.name;
			
									if (teamName.substr(0, 24).toUpperCase() === "CALENDARIO DEFINITIVO > ") {
										teamName = teamUpCalendarResponse.subcalendar.name.substr(24);
									}
									eventDetails.constructionApplicatorTeam = teamName;

									if (index === eventCount - 1) {
										resolve({
											currCCADetails,
											data: eventList,
											status: "ok"
										});
									}
								});
							}
							else {
								if (index === eventCount - 1) {
									resolve({
										currCCADetails,
										data: eventList,
										status: "ok"
									});
								}
							}
						}
						else {
							if (index === eventCount - 1) {
								resolve({
									currCCADetails,
									data: eventList,
									status: "ok"
								});
							}
						}
					});
				}
				else {
					resolve({
						currCCADetails: null,
						data: eventList,
						status: "ok"
					});
				}
			})
			.catch(error => {
				reject({
					currCCADetails: null,
					data: eventList,
					error,
					status: "ok"
				});
			});
		});
	}

	getSubCalendarFromName (name) {
		return new Promise((resolve, reject) => {
			this.getSubCalendars()
			.then(subCalendarsResponse => {
				name = name.toLowerCase();
				// const applicatorTeamList = Shark.get("applicatorTeamList");
				const subCalendars = subCalendarsResponse.data;

				const foundSubCalendars = subCalendars.filter(item => item.name.toLowerCase().indexOf(name) > -1);

				resolve({
					data: foundSubCalendars,
					status: "ok"
				});
			})
			.catch(error => {
				reject({
					data: null,
					error,
					status: "ko",
				});
			});
		});
	}

	getSubCalendars () {
		return new Promise((resolve, reject) => {
			fetch(`${this.get("baseApiURL").replace(/{{[\w.]+\}\}/g, "subcalendars")}`)
			.then(response => response.json())
			.then(teamUpResponse => {
				// console.log({teamUpResponse});
				// const applicatorTeamList = Shark.get("applicatorTeamList");
				const subCalendars = teamUpResponse.subcalendars;

				resolve({
					data: subCalendars,
					status: "ok"
				});
			})
			.catch(error => {
				reject({
					data: null,
					error,
					status: "ko",
				});
			});
		});
	}

	async updateDataByCCA (CCA) {
		//Dave: qui c'è qualcosa che non va nel return, trova prima di quando dovrebbe
		return this.getEventListByCCA(CCA)
		.then(async getEventListByCCAResponse => {
			// console.log({getEventListByCCAResponse});
			const ccaEventList = getEventListByCCAResponse.data;
			const ccaDetails = getEventListByCCAResponse.currCCADetails;
			let extraDates;
			let constructionSite;
			let constructionSiteCard;
			let quotation;

			if (ccaDetails) {
				const ccaDetailsListFromDB = await ccaDetailsManager.getByCCA(CCA);
				// console.log({ccaDetailsListFromDB})

				if (ccaDetailsListFromDB.data.length === 1) {
					const ccaDetailsToUpdate = ccaDetailsListFromDB.data[0];

					ccaDetails.set({
						extraData: ccaDetailsToUpdate.extraData,
						guid: ccaDetailsToUpdate.guid,
						note: ccaDetailsToUpdate.note,
						status: ccaDetailsToUpdate.status,
					});
					
					await ccaDetailsManager.save(ccaDetails)
					.then(response => {
						console.log(response);
					});
				}
				else {
					console.warn("Ne ho trovate due, non va bene!!!", {ccaDetailsListFromDB});
				}
			}

			if (ccaEventList.length > 0) {
				const { applicatorTeamList } = Shark.get();
				let applicatorTeamId = "";

				extraDates = ccaEventList.map(item => {
					if (applicatorTeamList) {
						const applicatorTeam = Utils.safp(applicatorTeamList, "name", item.constructionApplicatorTeam);

						if (applicatorTeam) {
							applicatorTeamId = applicatorTeam.guid;
							item.applicatorTeamId = applicatorTeamId;
						}
					}
					return item;
				});

				return quotationManager.getByCCA(CCA)
				.then(getQuotationResponse => {
					if (getQuotationResponse.status === "ok") {
						if (getQuotationResponse.data.length > 0) {
							quotation = getQuotationResponse.data[0];

							//Questa cosa andrà sistemata, per ora, visto che ci sono preventivi con vecchio sistema e nuovo insieme, allora modifico i dati in entrambi i posti.
							//	Penso che andrebbe rivista un po' tutta la struttura.
							if (quotation.lots && quotation.lots.length > 0) {
								const lotIndex = quotation.lots.findIndex(item => item.cca === CCA);

								if (lotIndex > -1) {
									quotation.lots[lotIndex].set({
										applicatorTeamId: extraDates[0].applicatorTeamId,
										multipleDates: extraDates,
										__timeSpanEnd: extraDates[extraDates.length - 1].constructionEndDateTime.format(Shark.get("dateISOFormat")),
										__timeSpanStart: extraDates[0].constructionStartDateTime.format(Shark.get("dateISOFormat")),
									});
								}
							}
							//else {
							quotation.set({
								"extraData.confirmData.timeSpanAndApplicatorTeam.applicatorTeamId": extraDates[0].applicatorTeamId,
								"extraData.confirmData.timeSpanAndApplicatorTeam.extraDates": extraDates,
								"__timeSpanEnd": extraDates[extraDates.length - 1].constructionEndDateTime.format(Shark.get("dateISOFormat")),
								"__timeSpanStart": extraDates[0].constructionStartDateTime.format(Shark.get("dateISOFormat")),
							});
							// }

							console.log({extraDates, applicatorTeamList, quotation});
							quotationManager.save(quotation);
						}
	
						return constructionSiteCardManager.getByCCA(CCA)
						.then(getConstructionSiteCardResponse => {
							if (getConstructionSiteCardResponse.data.length > 0) {
								constructionSiteCard = getConstructionSiteCardResponse.data[0];
		
								constructionSiteCard.set({
									applicatorTeamId: extraDates[0].applicatorTeamId,
									quotationExtraData: quotation.extraData,
									__endDate: extraDates[extraDates.length - 1].constructionEndDateTime.format(Shark.get("dateISOFormat")),
									__startDate: extraDates[0].constructionStartDateTime.format(Shark.get("dateISOFormat")),
								});

								console.log({extraDates, applicatorTeamList, quotation, constructionSiteCard});
								constructionSiteCardManager.save(constructionSiteCard);
							}

							return constructionSiteManager.getByCCA(CCA)
							.then(getConstructionSiteResponse => {
								if (getConstructionSiteResponse.data.length > 0) {
									constructionSite = getConstructionSiteResponse.data[0];
									
									constructionSite.set({
										applicatorTeamId: extraDates[0].applicatorTeamId,
										expectedEndDate: moment(extraDates[extraDates.length - 1].constructionEndDateTime.format(Shark.get("dateISOFormat"))),
										startDate: extraDates[0].constructionStartDateTime.format(Shark.get("dateISOFormat")),
									});

									constructionSiteManager.save(constructionSite);
									console.log({extraDates, applicatorTeamList, quotation, constructionSiteCard, constructionSite});
								}

								return {
									constructionSite,
									constructionSiteCard,
									quotation,
									status: "ok",
								};
							});
						});
					}
				});
			}
			else {
				return {
					status: "ko",
				};
			}
		});
	}
}

const teamUpManager = new TeamUpManager();

Shark.registerController(teamUpManager);

export default teamUpManager;
